import { useLocation, useNavigate } from "react-router-dom";
import HomeSvg from "../../assets/home.svg";
import RightArrow from "../../assets/rightArrowLight.svg";
import React, { useEffect, useState } from "react";
import { BreadCrumbsProps } from "../../types/breadCrumbs";

const convertBreadcrumb = (string: string) => {
  return string
    ?.replace(/-/g, ' ');
};

const Breadcrumb = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [breadcrumbs, setBreadcrumbs] = useState<any>([]);


  useEffect(() => {
    if (location) {
      const linkPath = location.pathname.split('/');
      linkPath.shift();

      const pathArray: any = linkPath.map((path, i) => {
        // Remove the query parameter from the last segment of the path
        const cleanPath = i === linkPath.length - 1 ? path.split('?')[0] : path;

        return { breadcrumb: cleanPath, href: '/' + linkPath.slice(0, i + 1).join('/') };
      });
      setBreadcrumbs(pathArray);
    }
  }, [location]);

  const handleBreadcrumbClick = (e: React.MouseEvent, href: string, breadcrumb: string, isLast: boolean) => {
    e.preventDefault();
    e.stopPropagation();

    // Don't navigate if clicking on the current page (last breadcrumb)
    if (isLast) {
      return;
    }

    const pathname = location.pathname;
    const isContractDetailPage = pathname.includes('/contract/view-contract/') ||
                                  pathname.includes('/contract/edit-contract/') ||
                                  pathname.includes('/contract/create-contract');

    const isSecurityPage = pathname.includes('/security/');

    // Special handling for contract detail pages - navigate to contract list
    if (isContractDetailPage) {
      navigate('/contract', {
        state: location?.state?.filter ? { filter: location.state.filter } : undefined
      });
    }
    // Special handling for security pages - clicking "security" stays on current page
    else if (isSecurityPage && breadcrumb === 'security') {
      // Don't navigate, stay on current security page
      return;
    }
    else {
      // Normal navigation
      navigate(href);
    }
  };


  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <nav aria-label="breadcrumbs">
        <ol className="flex ">
          <li>
            <a className="font-medium flex gap-1 cursor-pointer" onClick={(e) => { e.preventDefault(); navigate('/'); }}>
              <img src={HomeSvg} alt="HomeSvg" className="" />
            </a>
          </li>
          {breadcrumbs.map((breadcrumb: BreadCrumbsProps, i: number) => {
            const isLast = breadcrumbs?.length === i + 1;
            return (
              <li key={breadcrumb.href} className="flex items-center">
                <img src={RightArrow} alt="RightArrow" className="h-6 w-5" />
                <a
                  onClick={(e) => handleBreadcrumbClick(e, breadcrumb.href, breadcrumb.breadcrumb, isLast)}
                  className={`${isLast ? " pl-1 pr-2 rounded-md bg-[#EAECF0] " : " "}   capitalize inter-600-344054 flex gap-1   text-sm ${isLast ? '' : 'cursor-pointer'}`}
                >
                  {convertBreadcrumb(breadcrumb.breadcrumb)}
                </a>
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;
